export default function findAuthorizedVendorCount(vendorOptions: VendorOptionState[]): number {
  let authVendorCount = 0;
  vendorOptions.forEach((vendor) => {
    if (vendor.isAuthorizedDistributor) {
      authVendorCount++;
    }
  });

  return authVendorCount;
}
